export default __webpack_public_path__ + "static/media/img-discover.01452eea.svg";